import React from 'react';
import PropTypes from 'prop-types';
import {Table, Button, Input, Checkbox} from 'semantic-ui-react';
import UserAccountsNoSearchResult from './UserAccountNoSearchResult';
import UserAccountsSearchResult from './UserAccountsSearchResult';
import Pagination from '../../Pagination';

const UserAccounts = ({activePage, itemsPerPage, totalItems, items, isAdmin, onPaginate, onSearch, onSearchFieldChange, searchField, onLogin, onView, onIsAdminChange}) => {
    return (
        <Table celled>
        <Table.Header fullWidth>
            <Table.Row>
                <Table.HeaderCell colSpan="7">
                    <div className="accountSearch">
                        <Checkbox style={{marginTop: 10, marginRight: 10}} label="IsAdmin" checked={isAdmin} onChange={onIsAdminChange} />
                        <Input placeholder="Search Criteria..." onChange={onSearchFieldChange} value={searchField} />
                        <Button primary disabled={searchField === ''} onClick={onSearch}>Search</Button>
                    </div>
                </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
                <Table.HeaderCell>
                </Table.HeaderCell>
                <Table.HeaderCell>
                    Name
                </Table.HeaderCell>
                <Table.HeaderCell>
                    User Name
                </Table.HeaderCell>
                <Table.HeaderCell>
                    Email Address
                </Table.HeaderCell>
                <Table.HeaderCell>
                    Policies
                </Table.HeaderCell>
                <Table.HeaderCell>
                    eDelivery Enabled
                </Table.HeaderCell>
                <Table.HeaderCell>
                    IsAdmin
                </Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {!items.length ?
            <UserAccountsNoSearchResult /> : 
            items.map((item, index) => 
                <UserAccountsSearchResult key={index} user={item} onView={onView} onLogin={onLogin} />
            )}
        </Table.Body>
        <Table.Footer fullWidth>
            <Table.Row>
                <Table.HeaderCell colSpan="7">
                    {/* <Link to={'/admin/import'}>Import Users (don't use this)</Link> */}
                    <Pagination 
                        activePage={activePage}
                        itemsPerPage={itemsPerPage}
                        totalItems={totalItems}
                        pageRangeDisplayed={5}
                        floated="right"
                        onPaginate={onPaginate}
                        />  
                </Table.HeaderCell>
            </Table.Row>
        </Table.Footer>
    </Table>
    );
};

UserAccounts.propTypes = {
    activePage: PropTypes.number.isRequired,
    itemsPerPage: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
    items: PropTypes.array.isRequired,
    onPaginate: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onSearchFieldChange: PropTypes.func.isRequired,
    searchField: PropTypes.string.isRequired,
    onLogin: PropTypes.func.isRequired,
    onView: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    onIsAdminChange: PropTypes.func.isRequired,
};

export default UserAccounts;